/**
 * Phase 01 (security-hardening) Plan 08 — RateLimitToast
 *
 * Backend enforce moduna geçtiğinde ağır endpoint'ler `429 + Retry-After`
 * döndürür. Bu helper, kullanıcıya kaba bir hata ekranı yerine sakin,
 * tek satır, design-conscious bir bildirim gösterir:
 *   "Çok fazla istek. N saniye sonra tekrar deneyin."
 *
 * Görsel render eden bir component DEĞİL — side-effect helper (sonner `toast`).
 * `<Toaster>` main.tsx'te zaten mount edilmiştir.
 *
 * Tasarım kararları (UX design-conscious):
 * - `toast.warning`: sakin uyarı tonu; hata (kırmızı destructive) değil.
 * - Tek toast id `rate-limit`: art arda 429'lar yeni yeni toast yığmaz,
 *   Sonner aktif toast'ı dedupe eder — retry storm görsel gürültüsü olmaz.
 * - Kısa süreli (5sn); bekleme süresi mesajda yazılı, kalıcı olması gerekmez.
 */
import { toast } from 'sonner'

const RATE_LIMIT_TOAST_ID = 'rate-limit'

/**
 * Bekleme süresinden nazik, tek satır Türkçe bildirim metni üretir.
 * Saf fonksiyon — test edilebilir; toast tetiklemez.
 */
export function buildRateLimitMessage(retryAfterSeconds: number): string {
  const safe = Number.isFinite(retryAfterSeconds) && retryAfterSeconds > 0
    ? Math.ceil(retryAfterSeconds)
    : 60
  return `Çok fazla istek. ${safe} saniye sonra tekrar deneyin.`
}

/**
 * Rate-limit (429) durumunda kullanıcıya nazik bildirim gösterir.
 * @param retryAfterSeconds `Retry-After` header'ından okunan bekleme süresi (saniye).
 */
export function showRateLimitToast(retryAfterSeconds: number): void {
  toast.warning(buildRateLimitMessage(retryAfterSeconds), {
    id: RATE_LIMIT_TOAST_ID,
    duration: 5000,
    description: 'İsteklerinizi biraz yavaşlatın; kısa süre sonra tekrar deneyebilirsiniz.',
  })
}
